




























































































































































































import { QInput, QCard, QCardSection, QForm, QSelect, QBtn, QSeparator, QLinearProgress } from 'quasar';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import axios from 'axios';
import { GetEnoteZrss, PostPrijavnica } from '../../api';
import { IEnotaZrss } from '@/model';
import Checkmark from '../layout/checkmark.vue';

const getEmptyData = () => ({
    ustanova: {
        naziv: null,
        naslov: null,
        postna: null,
        kraj: null,
        davcna: null,
        enota_zrss: null,
    },
    kontaktna_oseba: {
        ime: null,
        telefon: null,
        email: null,
        email1: null,
    },
    storitev: {
        vrsta: null,
        cas_izpeljave_leto: null,
        cas_izpeljave_mesec: null,
        naslov_teme: null,
        pereca_vprasanja: null,
        ime_svetovalca: null,
    }
});


@Component({ components: { QInput, QCard, QCardSection, QForm, QSelect, QBtn, QSeparator, QLinearProgress, Checkmark } })
export default class Prijavnica extends Vue {
    private prijavnica = getEmptyData();
    private inProgress = false;
    private completed = false;
    private obmocneEnote: IEnotaZrss[] = [];

    private meseci = [
        'Januar',
        'Februar',
        'Marec',
        'April',
        'Maj',
        'Junij',
        'Julij',
        'Avgust',
        'September',
        'Oktober',
        'November',
        'December',
    ];
    private leta = [
        (new Date()).getFullYear(),
        (new Date()).getFullYear() + 1,
        (new Date()).getFullYear() + 2
    ];
    private storitve = [
        'predavanja/delavnice (za kolektiv/stopnjo) Cena delavnice je 225 EUR.',
        'svetovanje v podporo specifičnim ciljem predmetnih skupin/področij',
        'dolgotrajnejše oblike svetovanj',
        'svetovalne storitve po naročilu drugih inštitucij (npr. inšpektorata za šolstvo)',
    ];

    private mounted() {
        this.inProgress = true;
        GetEnoteZrss().then(a => this.obmocneEnote = a.data).finally(() => this.inProgress = false);
    }

    private reset() {
        this.$q.dialog({
            title: 'Pozor',
            message: 'Vsa polja bodo ponastavlena, kar pomeni da bodo vsi vnešeni podatki nepovratno izgubljeni. Želite nadaljevati?',
            cancel: "Ne",
            persistent: true,
            ok: 'Da',
        }).onOk(() => {
            this.prijavnica = getEmptyData();
            this.$q.notify({
                message: 'Polja so bila uspešno ponastavljnea',
                position: 'top',
                color: 'positive',
                icon: 'announcement'
            });
        }).onCancel(() => {
            // console.log('>>>> Cancel')
        }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
        });
    }

    private async submit() {

        try {
            this.inProgress = true;
            const res = await PostPrijavnica(this.prijavnica);
            this.$q.notify({
                message: 'Prijava uspešno oddana',
                caption: ' Potrditev prijave boste prejeli na e-mail naslov.',
                position: 'top',
                color: 'positive',
                icon: 'announcement'
            });
            this.completed = true;
        } catch {
            this.$q.notify({
                message: 'NAPAKA!',
                caption: ' Pri oddaji zahtevka je prišlo do napake. Prosim poizkusite ponovno.',
                position: 'top',
                color: 'negative',
                icon: 'announcement'
            });
        }
        finally {
            this.inProgress = false;

        }

    }

}
